import module from 'app/module.js'

let Catalogo

class $catalogosService {
  constructor ($filter, $api, $window) {
    this.$filter = $filter
    this.$api = $api
    this.$window = $window

    Catalogo = function (data) {
      Object.assign(this, data)
    }

    Catalogo.prototype.$select = function (filter, orderBy) {
      let list = Object.values(this)

      if (filter) {
        list = $filter('filter')(list, filter)
      }

      if (orderBy) {
        list = $filter('orderBy')(list, orderBy)
      }

      return list
    }
  }

  $fetch () {
    return this.$api.get('/app/catalogos', {}, {cache: 'catalogos'})
      .then((response) => {
        const catalogos = {}
        let data = JSON.parse(this.$window.atob(response))

        Object.keys(data).forEach((nombre) => (catalogos[nombre] = new Catalogo(data[nombre])))

        return catalogos
      })
  }

  get (catalogo, params) {
    return this.$api.get(`/app/catalogos/${catalogo}`, params || {}, {cache: 'catalogos'})
  }
}

module.service('$catalogos', $catalogosService)



// WEBPACK FOOTER //
// ./src/app/services/$catalogos.js